import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Page, Main, Title, Heading, Paragraph } from '../../components';

const EmailLukas = styled('span')({
  '&::before': {
    content: "'lr058@hd'",
  },
  '&::after': {
    content: "'m-stuttgart.de'",
  },
});

const EmailFabian = styled('span')({
  '&::before': {
    content: "'fh102@hd'",
  },
  '&::after': {
    content: "'m-stuttgart.de'",
  },
});

const View: FunctionComponent = () => (
  <Page>
    <Helmet>
      <title>Imprint | StudentsTinder</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <Main contentType="text">
      <Title>Imprint</Title>

      <Paragraph>
        StudentsTinder is a non-commercial project by students at the Hochschule
        der Medien in Stuttgart.
      </Paragraph>

      <Heading>Address</Heading>
      <Paragraph>
        Heerfeldstraße 17
        <br />
        71570 Oppenweiler
        <br />
        Germany
      </Paragraph>

      <Heading>Responsible for the content</Heading>
      <Paragraph>Lukas Rosenke, Fabian Hiller and Daniel Heinemann</Paragraph>

      <Heading>Contact</Heading>
      <Paragraph>
        Email: <EmailLukas /> or <EmailFabian />
      </Paragraph>
    </Main>
  </Page>
);

export default View;
